import React from 'react'
import { string } from 'prop-types'

import {
  ArrowLeft,
  ArrowRight,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const controlClass = `
  cgt-button
  cgt-button--ghost
  cgt-button--custom-color-legacy-white-100
  cgt-button--medium
  cgt-button--only-icon
  cgt-model-gallery__button`

function PrevIcon() {
  return <Icon svgComponent={ArrowLeft} />
}

function NextIcon() {
  return <Icon svgComponent={ArrowRight} />
}

function NavigationButton({ icon, customClass }) {
  return (
    <div className={`${controlClass} ${customClass}`}>
      {icon === 'ArrowLeft' ? (
        <PrevIcon />
      ) : (
        <NextIcon />
      )}
    </div>
  )
}

NavigationButton.propTypes = {
  icon: string.isRequired,
  customClass: string.isRequired,
}

export default NavigationButton
